import GridGalleryPreview from './GridGalleryPreview';
import CoverGalleryPreview from './CoverGalleryPreview';
import $ from 'jquery';

export default class ImageGallery {
	constructor(node, index) {
		this.node = node;
		this.index = index;
		this.init();
	}

	init() {
		this.gallery = this.isGrid() ? new GridGalleryPreview(this.node, this.index, 'grid') : this.isCover() ? new CoverGalleryPreview(this.node, this.index, 'cover') : false;
	}

	isGrid() {
		if (this.node.children('.gallery-preview-grid').length > 0) {
			return true;
		}
		return false;
	}

	isCover() {
		if (this.node.children('.gallery-preview__cover-image').length > 0) {
			return true;
		}
		return false;
	}

	getGallery() {
		return this.gallery;
	}

}